// extracted by mini-css-extract-plugin
export default {"root":"jW3kQDsiqFep8aDwj83C","primary":"T8XbtMoOEaAir0wIuSGJ","secondary":"oydbZ06enfffLzIFoguv","error":"whwvhPL58msxwhCrfuq6","success":"b4LW0EDyFJzDrFM5T7Xk"};